document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.wa-menu');
  const nav = document.querySelector('.wa-nav');
  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
  }
  document.querySelectorAll('.wa-nav a').forEach((link) => {
    link.addEventListener('click', () => nav?.classList.remove('is-open'));
  });
});
